import React, { memo/*, useCallback*/ } from 'react';
import PropTypes from 'prop-types';
import { Layout/*, notification*/ } from 'antd';
import style from './index.less';
/*import { SmileOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useUser } from '@dofleini/security';*/

const { Content } = Layout;

const GlobalLayout = ({ children }) => {
  /*
    const { isAuthenticated } = useUser();
    const { t } = useTranslation('process');
  */

  /*  const onCreateReingresoRequest = useCallback(() => {
    notification.open({
      message: t('incorporation.reEntrySend'),
      icon: <SmileOutlined className="text-primary"/>,
    });
  }, [t]);

  const onCloseCallback = useCallback((push, route) => {
    if (isAuthenticated)
      route && push && push(route);
  }, [isAuthenticated]);*/

  return (
    <Layout style={{ minHeight: '100vh' }} hasSider={false}>
      <Content className={style.mainLayout}>
        {children}
      </Content>
    </Layout>
  );
};

export default memo(GlobalLayout);

GlobalLayout.propTypes = {
  children: PropTypes.any
};
